export default __webpack_public_path__ + "static/media/cases3.530ca3f9.webp";